module.exports = __webpack_public_path__ + "img/introduction02_works_03.4fa65b3d.png";